import WrapIntl from "./src/utils/wrap-intl"

export const wrapPageElement = WrapIntl
